import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useEffect, useMemo, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { setSelectedCrystalId } from 'redux/reducers/synchrotronTripReducer';
import { useSelectedCrystalId } from './hooks';
import {
  TableColumns,
  unAssignedCrystalsTableColumns,
  UnAssignedCrystalsTableData,
} from './utils';
import { CrystalDataDTO, SynchTripStatus } from './constants';
import RMButton from 'components/customComponents/Controls/RMButton';
import { IStyle } from 'Styles';
import { FmlxButton } from 'fmlx-common-ui';

interface Props {
  unassignedCrystals: CrystalDataDTO[];
  assignCrystals: (e: any) => void;
  synchTripStatus: SynchTripStatus;
  isReadOnly?: boolean;
}

const UnassignedCrystals = (props: Props) => {
  const { unassignedCrystals, assignCrystals, synchTripStatus, isReadOnly } = props;
  const dispatch = useRMDispatch();
  const tableColumns: TableColumns[] = unAssignedCrystalsTableColumns;
  const [selectedRows, setSelectedRows] = useState<number[]>();
  const [selectedCrystalId] = useSelectedCrystalId();

  const handleSelectionChange = (rowIndices: number[]) => {
    setSelectedRows([...rowIndices]);
    dispatch(setSelectedCrystalId(unassignedCrystals[rowIndices.pop()]?.id));
  };

  const handleAssignCrystals = () => {
    const crystalIds = selectedRows.map((r) => crystalsList_[r]?.id);
    assignCrystals(crystalIds);
    setSelectedRows([]);
  };

  const handleOnRowCLick = (row) => {
    setSelectedRows([row.index]);
    dispatch(setSelectedCrystalId(unassignedCrystals[row.index]?.id));
  };

  const handleRowDoubleClick = (row) => {
    const dropInfo = unassignedCrystals[row.index]?.crystalDropInfo;
    const url = `/exp/${dropInfo.expId}/${dropInfo.plateId}/${dropInfo.wellNumber}/${dropInfo.dropNumber}/${dropInfo.cpId}/${dropInfo.regionName}/${dropInfo.imageBatchId}/drop`;
    window.open(url, url);
  };

  const crystalsList_: UnAssignedCrystalsTableData[] = useMemo(
    () =>
      unassignedCrystals?.map((uc: CrystalDataDTO) => ({
        id: uc.id,
        crystalName: uc.name,
        harvestFrom: uc.harvestFrom,
        owner: uc.ownerName,
      })),
    [unassignedCrystals],
  );

  useEffect(() => {
    dispatch(setSelectedCrystalId(0));
  }, []);

  return (
    <div id="synchrotron-unassignedcrystals-wrapper" className="w-full overflow-auto">
      <div
        id="synchrotron-unassignedcrystals-header"
        className="flex justify-between align-middle"
      >
        <span
          id="synchrotron-unassignedcrystals-header-title"
          className="text-lg font-bold w-1/2"
        >
          Unassigned Crystals ({unassignedCrystals?.length})
        </span>
        <span
          id="synchrotron-unassignedcrystals-header-assigncrystals-button"
          className="text-lg font-bold w-1/2 flex justify-end"
        >
          <RMButton
            id='unassignedcrsytals-assign-button'
            onClick={handleAssignCrystals}
            className="text-white text-sm px-2 py-1 mb-1 border-0 outline-none hover:bg-green-600 disabled:bg-gray-300"
            disabled={
              !selectedCrystalId ||
              unassignedCrystals.length <= 0 ||
              synchTripStatus !== SynchTripStatus.Open ||
              isReadOnly
            }
            customStyle={styles.applyButton}
            label="ASSIGN CRYSTALS"
            type={FmlxButton.Type.POSITIVE}
          />
        </span>
      </div>
      {crystalsList_ && (
        <div
          id="synchrotron-unassignedcrystals-table"
          className="synch_td overflow-auto p-0.5"
        >
          <RMTable
            columns={[...tableColumns]}
            data={crystalsList_}
            selectedIds={selectedRows}
            onCheckboxSelectionChange={handleSelectionChange}
            enableMultiSelection={true}
            tableClass="w-full"
            onRowClicked={handleOnRowCLick}
            onRowDoubleClicked={handleRowDoubleClick}
          />
        </div>
      )}
    </div>
  );
};
const styles: IStyle = {
  applyButton: {
    backgroundColor: '#4AAE53',
    width: '10.5rem',
  },
};
export default UnassignedCrystals;
